import React from "react";
import { experience } from "../data";
import "./PageStyles.css";

const ExperiencePage = () => (
  <div className="page">
    <header className="page-header">
      <h1 className="section-title">Work Experience</h1>
      <p className="page-lead">Roles, responsibilities, and impact.</p>
    </header>
    <section className="section">
      <div className="container">
        <div className="experience-list">
          {experience.map((exp) => (
            <div key={exp.id} className="experience-card">
              <div className="experience-header">
                <div>
                  <h3 className="experience-title">{exp.title}</h3>
                  <p className="experience-company">{exp.company}</p>
                </div>
                <div className="experience-meta">
                  <span className="experience-duration">{exp.duration}</span>
                  <span className="experience-location">{exp.location}</span>
                </div>
              </div>
              <ul className="experience-responsibilities">
                {exp.responsibilities.map((resp, index) => (
                  <li key={index}>{resp}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  </div>
);

export default ExperiencePage;

